import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/en';
import { translations as esTranslations } from '../translations/es';
import FullBleedImage from '../components/FullBleedImage';

const About = () => {
  const { language } = useLanguage();
  const t = language === 'en' ? translations : esTranslations;

  return (
    <div className="font-inter bg-[#f5f5f7] text-[#1a2233] min-h-screen">
      <div className="h-6 md:h-10" />
      {/* Hero Section */}
      <section className="relative h-[48vh] flex items-center justify-center overflow-hidden">
        <img
          src="/images/flowers2.jpg"
          alt="Assemblage Bodas Team"
          className="absolute inset-0 w-full h-full object-cover object-center z-0 transition hover:brightness-110"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a2233]/90 via-[#23283a]/60 to-transparent"></div>
        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-playfair text-white mb-4 drop-shadow-[0_4px_24px_rgba(24,28,36,0.9)]">
            <span className="border-b-4 border-[#c7a16e] pb-2">{t.about.heroTitle}</span>: {t.about.heroSubtitle}
          </h1>
          <p className="text-lg md:text-xl text-white font-light drop-shadow-[0_2px_12px_rgba(24,28,36,0.8)] mb-6">
            {t.about.heroDescription}
          </p>
        </div>
      </section>

      {/* Founder/Philosophy Section */}
      <section className="py-20 px-6 md:px-0 bg-white">
        <div className="max-w-2xl mx-auto text-center">
          <img
            src="/images/prof.jpg"
            alt="Shirley Shaw, Founder"
            className="rounded w-32 h-32 object-cover mx-auto mb-6 border-4 border-[#f7e6df] shadow-lg transition hover:brightness-110"
          />
          <h2 className="text-3xl md:text-4xl font-playfair mb-4 text-[#1a2233]">
            {t.about.philosophyTitle}
          </h2>
          <p className="text-lg text-[#1a2233] mb-6 font-light">
            {t.about.philosophyText}
          </p>
          
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6 md:px-0 bg-[#f5f5f7] text-center">
        <Link
          to="/contact"
          className="bg-[#c7a16e] text-white py-4 px-10 rounded-full text-lg font-medium hover:bg-[#b08a5a] transition-all duration-300 shadow-lg tracking-wide"
        >
          {t.cta.begin}
        </Link>
      </section>

      {/* Full-bleed image sliver above footer */}
      <FullBleedImage 
        src="https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
        alt="Luxury wedding in Mexico"
      />
    </div>
  );
};

export default About; 